import {
  Center,
  Flex,
  FlexProps,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Skeleton,
} from "@chakra-ui/react";
import { useController } from "react-hook-form";
import { useCallback } from "react";
import PercentInput from "components/Shared/Forms/PercentInput";
import { getPercentValue } from "utils/formatting";
import {
  BIG_PINK_INPUT_PROPS,
  InputComponentProps,
} from "./pricingCalculatorUtils";

type Props = FlexProps & InputComponentProps;

export default function PricingPercentInput({
  formContext,
  loading,
  name,
  ...rest
}: Props) {
  const { control } = formContext;
  const { field } = useController({ name, control });

  const { onChange, value } = field;

  const handleSliderChange = useCallback(
    (newValue: number) => {
      const pctValue = getPercentValue(newValue, { isToDecimal: true });
      onChange?.(
        typeof pctValue === "number" && !Number.isNaN(pctValue)
          ? String(pctValue)
          : pctValue,
      );
    },
    [onChange],
  );

  return (
    <Flex flexWrap="wrap" justifyContent="flex-end" {...rest}>
      <Center
        flex="1 0 0"
        minWidth="8em"
        backgroundColor="white"
        borderRadius="xl"
        px={4}
        py={2}
        my={2}
      >
        <Slider
          focusThumbOnChange={false}
          value={getPercentValue(value ? parseFloat(value) : undefined)}
          onChange={handleSliderChange}
          isDisabled={loading}
          min={0}
          max={99}
        >
          <SliderTrack>
            <SliderFilledTrack />
          </SliderTrack>
          <SliderThumb />
        </Slider>
      </Center>

      <Skeleton
        isLoaded={!loading}
        width="6em"
        flex="0 0 auto"
        my={2}
        ml={6}
        borderRadius={10}
      >
        <PercentInput
          {...field}
          {...BIG_PINK_INPUT_PROPS}
          textAlign="right"
          max={99}
          decimalScale={2}
          allowNegative={false}
        />
      </Skeleton>
    </Flex>
  );
}
